import type { FormRulesStructure } from '../model/form-rules.types';
import type { FormStructure } from '../model/form.types';
import type { MatrixAnswers } from '../model/types';
import { isEmptyValue } from './definitions/shared';
import { currentValue, fieldEntries, migratedElements, snapshotFields } from './field-walk';
import { evaluateRules } from './rules';

export interface RevealedFieldsInput {
  structure: FormStructure;
  rules: FormRulesStructure | null;
  opened: MatrixAnswers;
  corrected: MatrixAnswers;
}

function isActive(outcome: { visible: boolean; enabled: boolean }): boolean {
  return outcome.visible && outcome.enabled;
}

// A required field a rule hid or disabled may rightly stay empty. When a later response (a plain
// one, an Upload edit or a correction) changes the value the rule reads and brings the field back,
// the new photo owes it like a sheet would. Only fields count, by id: a cell of a historical row of
// a multiple table is owed only when the response writes it. Emptiness is read through
// currentValue, the value compile validates.
export function revealedRequiredFieldIds(input: RevealedFieldsInput): string[] {
  const elements = migratedElements(input.structure);
  const before = evaluateRules(input.rules, snapshotFields(elements, input.opened));
  const after = evaluateRules(input.rules, snapshotFields(elements, input.corrected));
  const revealed = new Set<string>();

  for (const { element } of fieldEntries(elements)) {
    if (element.properties.required !== true || revealed.has(element.id)) continue;
    if (!isActive(after(element.id)) || isActive(before(element.id))) continue;
    if (isEmptyValue(currentValue(element, input.corrected))) revealed.add(element.id);
  }

  return [...revealed];
}
